import React, { useEffect, useState } from 'react';
import { User2,ArrowLeft,Phone,FileText,LogOut, ShieldCheck,Info, ChevronRight,Ban} from 'lucide-react';
import MobileNav from '../components/MobileNav'
// import PlayStore from '../assets/playstore.png'
import Huwaei from '../assets/huwaei.svg'
// import Apple from '../assets/appleicon.png'


import Apple from '../assets/apple-logo-svgrepo-com (1).svg'
import PlayStore from '../assets/playstore-svgrepo-com.svg'

export default function Profile() {
  const [data, setData] = useState({});
  const [iframeSrc, setIframeSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [os, setOS] = useState(null);




  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("Laki_user_data"));
    setData(userData || {});
   
  }, []);

  const openOffcanvas = (url) => {
    setIsLoading(true); // Show loader
    setIframeSrc(url);
    const offcanvas = document.getElementById('profileOffcanvas');
    if (offcanvas) {
      offcanvas.classList.add('show');
      offcanvas.style.visibility = 'visible';
      offcanvas.style.transform = 'translateX(0)';
      document.body.classList.add('offcanvas-open');
    }
  };


  const closeOffcanvas = () => {
    const offcanvas = document.getElementById('profileOffcanvas');
    if (offcanvas) {
      offcanvas.classList.remove('show');
      offcanvas.style.visibility = 'hidden';
      offcanvas.style.transform = 'translateX(100%)';
      document.body.classList.remove('offcanvas-open');
    }
    setIframeSrc('');       // Clear iframe
    setIsLoading(false);    // Reset loader
  };


  useEffect(() => {
    const loadGTranslate = () => {
      window.gtranslateSettings = {
        default_language: "en",
        languages: ["en", "fr", "ar", "ru", "id"],
        wrapper_selector: ".gtranslate_wrapper",
      };
  
      const script = document.createElement("script");
      script.src = "https://cdn.gtranslate.net/widgets/latest/dropdown.js";
      script.defer = true;
      script.onload = () => {
        console.log("GTranslate script loaded.");
      };
  
      document.body.appendChild(script);
      return script; // return the script so we can clean it up later
    };
  
    let scriptRef;
  
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        scriptRef = loadGTranslate();
      }, { timeout: 2000 });
    } else {
      setTimeout(() => {
        scriptRef = loadGTranslate();
      }, 2000);
    }
  
    return () => {
      if (scriptRef && scriptRef.parentNode) {
        scriptRef.parentNode.removeChild(scriptRef);
      }
      delete window.gtranslateSettings;
    };
  }, []);
  


  useEffect(() => {
    const getMobileOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      } else if (/android/i.test(userAgent)) {
        return "Android";
      } else if (/huawei|honor/i.test(userAgent)) {
        return "Huawei";
      } else {
        return "Other";
      }
    };

    setOS(getMobileOS());
  }, []);



  function Logout(){
    localStorage.removeItem("Laki_user_data");
    window.location.href = '/';
  }

  return (
    <div>
      <section className='container'>
        <div className='d-flex flex-row align-items-center justify-content-between my-4'>
          <div className='d-flex flex-row align-items-center justify-content-between gap-2' >
            <ArrowLeft
              size={30}
              color='white'
              onClick={() => window.location.href = '/home'}
              style={{ cursor: 'pointer' }}
            />
            <h2 className='pink'>Profile</h2>
          </div>

          <button className='btn btn-primary my-7' style={{ float: 'right' }} onClick={()=>Logout()}>  <LogOut size={18} className="text-secondary" /> Logout</button>
        </div>

        <div className='d-flex flex-row align-items-center justify-content-between' >
          <h4 className='text-light mb-3'>User</h4>
          <span className="badge text-bg-success">{data.Description}</span>
        </div>
        <ul className="list-group mb-4">
          <li className="list-group-item d-flex flex-row align-items-center gap-3">
            <User2 size={18} className="text-secondary" />
            <strong className='pink'>User ID</strong> {data.UserID}
          </li>

          <li className="list-group-item d-flex flex-row align-items-center gap-3">
            <Phone size={18} className="text-secondary" />
            <strong className='pink'>Phone</strong> +{data.Phone}

          </li>


        </ul>

        <h4 className='text-light mb-3'>Account Info</h4>
        <ul className="list-group mb-4">
          {data.ShowPP && (
            <li className="list-group-item d-flex flex-row align-items-center gap-3">
              <FileText size={18} className="text-secondary" />
              <button className="btn pink p-0 d-flex flex-row justify-content-between w-100" onClick={() => openOffcanvas('https://d2saof99ugqr6h.cloudfront.net/PrivacyPolicy?id=864&langcode=en')}>
                Privacy Policy <ChevronRight />
              </button>
            </li>
          )}
          {data.ShowTC && (
            <li className="list-group-item d-flex flex-row align-items-center gap-3">
              <ShieldCheck size={18} className="text-secondary" />
              <button className="btn pink p-0 d-flex flex-row justify-content-between w-100" onClick={() => openOffcanvas('https://d2saof99ugqr6h.cloudfront.net/TermsAndConditions?id=864&langcode=en')}>
                Terms & Conditions <ChevronRight />
              </button>
            </li>
          )}
          {data.showMyAccountDetails && (
            <li className="list-group-item d-flex flex-row align-items-center gap-3">
              <Info size={18} className="text-secondary" />
              <button className="btn pink p-0 d-flex flex-row justify-content-between w-100" onClick={() => openOffcanvas(`https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${data.billingChannelId}&MSISDN=${data.phone}&langCode=en`)}>
                My Account Details <ChevronRight />
              </button>
            </li>
          )}
          {data.showUnsub && (
            <li className="list-group-item d-flex flex-row align-items-center gap-3">
              <Ban size={18} className="text-secondary" />
              <button className="btn pink p-0 d-flex flex-row justify-content-between w-100" onClick={() => openOffcanvas(`https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${data.billingChannelId}&MSISDN=${data.phone}&langCode=en`)}>
                Subscription Info <ChevronRight />
              </button>
            </li>
          )}
        </ul>



        <h4 className='text-light' >Language</h4>
        <div className="gtranslate_wrapper"></div>



        <h4 className='text-light mt-4' >Download Our App</h4>

        <div className='d-flex flex-row gap-2 pt-2 flex-wrap' style={{marginBottom:'5rem'}}>
          {(os === 'iOS' || os === 'Other') && (
            <a href='https://apps.apple.com/app/id1478271139' target='_blank' className='btn-os'>
              <img src={Apple} />
              <div>
                <span>DOWNLOAD ON THE</span>
                <p>App Store</p>
              </div>
            </a>
          )}

          {(os === 'Android' || os === 'Other') && (
            <a href='https://play.google.com/store/apps/details?id=com.videos.entertainment' target='_blank' className='btn-os'>
              <img src={PlayStore} />
              <div>
                <span>GET IT ON</span>
                <p>Google Play</p>
              </div>
            </a>
          )}

          {(os === 'Huawei' || os === 'Other') && (
            <a href='https://appgallery.huawei.com/#/app/C106088175' target='_blank' className='btn-os'>
              <img src={Huwaei} />
              <div>
                <span>DOWNLOAD ON THE</span>
                <p>App Gallery</p>
              </div>
            </a>
          )}
        </div>



        {/* Right Offcanvas */}
        <div
          id="profileOffcanvas"
          className="offcanvas offcanvas-end"
          style={{
            width: '80%',
            position: 'fixed',
            top: 0,
            right: 0,
            height: '100vh',
            backgroundColor: 'white',
            zIndex: 1050,
            transition: 'transform 0.3s ease-in-out',
            visibility: 'hidden',
            transform: 'translateX(100%)'
          }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">Details</h5>
            <button type="button" className="btn-close" onClick={closeOffcanvas}></button>
          </div>
          <div className="offcanvas-body p-0">
            <iframe
              src={iframeSrc}
              title="Info Frame"
              width="100%"
              height="100%"
              frameBorder="0"
              onLoad={() => setIsLoading(false)}
              style={{ border: 'none', display: isLoading ? 'none' : 'block' }}
            ></iframe>
          </div>
          {isLoading && (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
              <div className="spinner-border  pink" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>

      </section>
      <br></br>
      <MobileNav />
    </div>
  );
}
